module.exports = THREE